export default __webpack_public_path__ + "static/media/cropped_dodge.7b26b687.png";